// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"54ea23f3","455":"0b569ad5"}[chunkId] + ".chunk.js";
};